/**
 * @file 自定义服务列表
 * @author fuqiang15
 */

import ListModel from '@baidu/ve-ria/views/ListModel';
import {assign} from 'lodash';

export default class AppListModel extends ListModel {
    /**
     * @override
     */
    title = '';

    crumbData = [
        {
            to: '/app/service/list',
            text: '服务管理'
        },
        {text: 'API管理'}
    ];

    protocolMap = this.getConstantMap('API_PROTOCOL');
    methodMap = this.getConstantMap('API_REQUEST_METHOD');

    filter = assign(this.filter, {
        appId: null,
        serviceId: null,
        timeRange: null
    });
    extra = null

    init() {
        let {appId, serviceId} = this.getRouteParams();
        this.filter.appId = appId;
        this.filter.serviceId = serviceId;

        super.init();
        if (this.crumbData.length && appId) {
            this.crumbData[0].to = `/app/${appId}/service/list`;
        }

        this.listRequester = this.api.appServiceCustomAPIList;
        this.reviewRequester = this.api.appServiceCustomReview;
        this.apiDeleteRequester = this.api.appServiceCustomAPIDelete;
        this.offlineServiceRequester = this.api.appServiceCustomOffline;
    }

    adaptData(data) {
        this.extra = data.extra;
        return super.adaptData(data);
    }

    reviewService() {
        return this.reviewRequester({id: this.filter.serviceId});
    }

    deleteApi(id) {
        return this.apiDeleteRequester({id});
    }
}
